import { lazy } from "react";
import { 
  Home, 
  User2, 
  Settings2, 
  Users, 
  Calendar, 
  Receipt, 
  Building2, 
  UserRound, 
  BadgeCheck, 
  Plug,
  AlertCircle
} from "lucide-react";


// Lazy load pages for better performance
const Landing = lazy(() => import("@/pages/auth/Landing"));
const SignupEmailVerification = lazy(() => import("@/pages/auth/SignupEmailVeification"));
const SignupOrganizationInfo = lazy(() => import("@/pages/auth/SignupOrganizationInfo"));
const Login = lazy(() => import("@/pages/auth/Login"));
const Register = lazy(() => import("@/pages/auth/Register"));
const ChangePassword = lazy(() => import("@/pages/auth/ChangePassword"));
const ForgotPassword = lazy(() => import("@/pages/auth/forgot-password/ForgotPassword"));
const Dashboard = lazy(() => import("@/pages/dashboard/Dashboard"));
const Profile = lazy(() => import("@/pages/profile/Profile"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// New pages based on Onnspot structure
const Contact = lazy(() => import("@/pages/contact/Contact"));
const Appointment = lazy(() => import("@/pages/appointment/Appointment"));
const ExpenseSheet = lazy(() => import("@/pages/expense-sheet/ExpenseSheet"));

// Settings pages
const Organization = lazy(() => import("@/pages/setting/organization/Organization"));
const Employee = lazy(() => import("@/pages/setting/employee/Employee"));
const Designation = lazy(() => import("@/pages/setting/designation/Designation"));
const Integration = lazy(() => import("@/pages/setting/integration/Integration"));

// Debug pages (only available in development)
const ApiDebug = lazy(() => import("@/pages/debug/ApiDebug"));

/**
 * Route configuration for the application
 * This centralized configuration makes it easy to manage routes
 * Based on Onnspot project structure
 */
export const routes = [
  // Public routes (accessible without authentication)
  {
    path: "/",
    element: Landing,
    public: true,
  },
  {
    path: "/signup/email-verification",
    element: SignupEmailVerification,
    public: true,
  },
  {
    path: "/signup/organization-info",
    element: SignupOrganizationInfo,
    public: true,
  },
  {
    path: "/login",
    element: Login,
    public: true,
    name: "Login",
  },
  {
    path: "/register",
    element: Register,
    public: true,
  },
  {
    path: "/change-password",
    element: ChangePassword,
    public: true,
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
    public: true,
  },

  // Dashboard route
  {
    path: "/dashboard",
    element: Dashboard,
    public: false,
    name: "Dashboard", // Name for the sidebar menu
    icon: Home, // Icon for the sidebar menu
  },

  // Contact management
  {
    path: "/contact",
    element: Contact,
    public: false,
    name: "Contact",
    icon: Users,
  },

  // Appointment management
  {
    path: "/appointment",
    element: Appointment,
    public: false,
    name: "Appointment",
    icon: Calendar,
  },

  // Expense tracking
  {
    path: "/expense-sheet",
    element: ExpenseSheet,
    public: false,
    name: "Expense Sheet",
    icon: Receipt,
  },

  // Settings routes
  {
    path: "/setting/organization",
    element: Organization,
    public: false,
    name: "Organization",
    icon: Building2,
    group: "Settings",
  },
  {
    path: "/setting/employee",
    element: Employee,
    public: false,
    name: "Employee",
    icon: UserRound,
    group: "Settings",
  },
  {
    path: "/setting/designation",
    element: Designation,
    public: false,
    name: "Designation",
    icon: BadgeCheck,
    group: "Settings",
  },
  {
    path: "/setting/integration",
    element: Integration,
    public: false,
    name: "Integration",
    icon: Plug,
    group: "Settings",
  },

  // Profile route
  {
    path: "/profile",
    element: Profile,
    public: false,
    name: "Profile",
    icon: User2,
  },
  
  // Debug routes (only available in development)
  {
    path: "/debug/api",
    element: ApiDebug,
    public: false, // Requires authentication for security
    name: "API Debug",
    icon: AlertCircle,
    group: "Debug",
    // Only show in development mode
    hidden: import.meta.env.VITE_APP_ENV === "production",
  },
  

  // 404 page
  {
    path: "*",
    element: NotFound,
    public: true,
  },
];

export default routes;
